import { DatePicker, FormField, Select, todayIso } from '@ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDialog } from '../../../app/FormDialog';
import { errorMessage } from '../../../lib/errors';
import type { PaymentMethod } from '../api';

const METHODS: PaymentMethod[] = ['cash', 'transfer', 'paypal', 'other'];

export interface PaymentDialogProps {
  open: boolean;
  onClose: () => void;
  description?: string | undefined;
  pending: boolean;
  error: unknown;
  onSubmit: (method: PaymentMethod, on: string) => void;
}

/** Payment date and method (SAL-002, INVC-010). */
export function PaymentDialog({
  open,
  onClose,
  description,
  pending,
  error,
  onSubmit,
}: PaymentDialogProps) {
  const { t } = useTranslation();
  const [on, setOn] = useState(todayIso());
  const [method, setMethod] = useState<PaymentMethod>('transfer');
  return (
    <FormDialog
      open={open}
      onClose={onClose}
      title={t('sales.payment.title')}
      description={description}
      submitLabel={t('sales.payment.submit')}
      onSubmit={() => onSubmit(method, on)}
      pending={pending}
      error={error ? errorMessage(error) : undefined}
    >
      <FormField label={t('sales.payment.on')} required>
        {(p) => <DatePicker {...p} value={on} onChange={setOn} max={todayIso()} />}
      </FormField>
      <FormField label={t('sales.form.method')} required>
        {(p) => (
          <Select
            {...p}
            value={method}
            onChange={(e) => setMethod(e.target.value as PaymentMethod)}
            options={METHODS.map((m) => ({ value: m, label: t(`sales.method.${m}`) }))}
          />
        )}
      </FormField>
    </FormDialog>
  );
}
